<template>
  <div class="contactPage" id="tinyScreenContact">
    <Header></Header>
    <!-- banner -->
    <div ref="box" class="box" :style="{height: scrollerHeight,backgroundImage:'url('+pcAdvertUrl+')'}">
        <div class="contactBox">
         <!--  <img class="location" width="55px" src="../../assets/picture/contact/t8.png"> -->
          <div class="txt">
         <!--    <span>{{$t('contact.china')}}</span>
            <i>·</i>
            <span>{{$t('contact.shanghai')}}</span> -->
          </div>
          <div class="emailBox">
            <img src="../../assets/picture/contact/t7.png">
            <span>info@jqinvestments.com</span>
          </div>
        </div>
    </div>
    <!-- footer -->
    <Footer></Footer>
  </div>
</template>

<script>
import Header from '../common/header';
import Footer from '../common/footer';
export default {
  data() {
    return {
      isShowSearch:false,
      fullHeight: '',
      width:0,
      height:0,
      scrollerHeight:'',
      pcAdvertUrl:'',
      mobileAdvertUrl:''
    };
  },
  components: { Header,Footer },
  mounted(){
    this.getFullHeight();
    this.getAdvert();
     this.width =  window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    this.height =  window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
    if(this.width<1023){
      this.scrollerHeight = (window.innerHeight-60) + 'px';
    }
  },
  watch: {
      // 如果 `fullHeight ` 发生改变，这个函数就会运行 
      fullHeight :function(val) {
        if(!this.timer) {
          this.fullHeight = val
          this.changeFixed(this.fullHeight)
          this.timer = true
          let that = this
          setTimeout(function (){//频繁触发 resize 函数，会导致页面很卡
            that.timer = false
          },100)
        }
      },
  },
  beforeMount(height) {
    var h = document.documentElement.clientHeight || document.body.clientHeight;
    this.curHeight =h - height; //减去页面上固定高度height
  },
  methods: {
    formatTooltip(val) {
        return val / 100;
      },
     changeFixed(fullHeight){                        //动态修改样式
      this.$refs.box.style.height =( 0.91*fullHeight - 85)+'px';
     },
    getFullHeight(){
        this.fullHeight= `${document.documentElement.clientHeight}`;//默认值
        const that = this
        window.onresize = () => {
          return (() => {
            window.fullHeight = document.documentElement.clientHeigh
            that.fullHeight = window.fullHeight
          })()
        }
    },
    showSearch(){
      this.isShowSearch = !this.isShowSearch;
    },
     // 根据埋点ID及非必填项获取广告位
    async getAdvert() {
        const { data: res } = await this.$http.get("/advert/getAdvert.do?pointId=9");
        // 提示message
        if (res.code !== 200) return this.$message.error(res.message);
        this.pcAdvertUrl = res.data[0].pcAdvertUrl;
        this.mobileAdvertUrl = res.data[0].mobileAdvertUrl;
    },
  }
};
</script>

<style lang="less" scoped>
.contactPage{
  width: 100%;
    height: 100%;
  .box{
    background-image: url(../../assets/picture/contact/p17.png);
    background-position: center center;
    background-size: cover;
    width: 100%;
    height: 100%;
    position: relative;
    .contactBox{
      position: absolute;
         top: 50%;
         left: 50%;
         transform: translate(-50%, -50%);
      .location{
        display: block;
        margin:0 auto;
        margin-bottom: 55px;
      }
      .txt{       
        font-size: 70px;
        font-family: PingFangSC-Light, PingFang SC;
        font-weight: 300;
        color: #F2F2F2;
        line-height: 98px;
        letter-spacing: 14px;
        text-align: center;
        margin-bottom: 40rem;
        i{
          margin:0 50px;
        }
      }
      .emailBox{
        text-align: center;
        img{
          width: 40px;
          margin-right: 30px;
        }
        span{         
          font-size: 20px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #F2F2F2;
          line-height: 20px;
        }
      }
    }
  }
}
</style>
